import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0386732b&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=0386732b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386732b",
  null
  
)

export default component.exports